import {FC} from 'react'
import moment from 'moment'
import {List, ListHeader, ListItem, ListArrow, AlertLink, Indicator} from './List'
import {VisaAlertEmployee} from './query'
import styles from './VisaAlerts.scss'

interface VisaAlertsProps {
  employees: VisaAlertEmployee[]
}

export const VisaAlerts: FC<VisaAlertsProps> = ({employees}) => {
  if (employees.length === 0) {
    return null
  }

  return (
    <div>
      <ListHeader>在留期間更新が必要な従業員がいます</ListHeader>
      <List>
        {employees.map((employee) => (
          <ListItem key={employee.id}>
            <AlertLink to={`/employees/${employee.id}/visa_history`}>
              <Indicator />
              <span className="u-mr5">{employee.displayFullName}</span>
              <span className={styles.expirationDate}>
                在留期間満了日：{moment(employee.visaHistory.visaUntil).format('LL')}
              </span>
              <ListArrow />
            </AlertLink>
          </ListItem>
        ))}
      </List>
    </div>
  )
}
